import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { AppComponent } from '../../../../app.component';
import { AdministrationService, StorageService } from '../../service';
import { MenuItem } from 'primeng/api';
import { distinctUntilChanged, filter, Observable } from 'rxjs';
import { select, Store } from '@ngrx/store';
import { Router } from '@angular/router';
@Component({
    selector: 'app-menu',
    templateUrl: './app.menu.component.html',
    styleUrls: ['./app.menu.component.scss']
})
export class AppMenuComponent implements OnInit {
    userDetails = JSON.parse(localStorage.getItem("userDetails"))
    privileges: any
    model: {}[];
    items: MenuItem[] = [];
    isSuperuser: boolean = false;
    isCozentusUser: boolean = false;
    selectedClientId$: any
    privilegeList$: any
    showApp: boolean;
    fullPageDialog: boolean;
    activeIndex: number=-1;

    constructor(private router: Router,private cdr: ChangeDetectorRef, private store: Store<any>, public adminService: AdministrationService, public app: AppComponent, public storageService: StorageService) {
        this.selectedClientId$ = this.store.pipe(select(state => state?.data?.data));
        // privileges$ = this.store.pipe(select(state => state?.lists));
    }

    ngOnInit() {
        this.setActiveMenuItem();
        this.privileges = JSON.parse(localStorage.getItem("RolePrivilege"))
        this.isSuperuser = this.userDetails?.is_superuser || false;
        this.isCozentusUser = this.userDetails?.email ? this.userDetails?.email?.includes('cozentus') : false;

        let isManual = localStorage.getItem('manual-logged-in') === 'true';
        if (!isManual) {

            setTimeout(() => {
                this.adminService.selectedClientId$.subscribe((clientId) => {
                    this.populateMenuItems(this.privileges, clientId);
                    // this.cdr.detectChanges();
                });
            }, 3000)

        } else {
            this.fullPageDialog = true;
            const checkInterval = setInterval(() => {
                const privileges = JSON.parse(localStorage.getItem("RolePrivilege"));
                const clientId = localStorage.getItem("selectedClientId");

                if (privileges && clientId) {
                    this.privileges = privileges;
                    this.showApp = true;
                    this.populateMenuItems(this.privileges, clientId);
                    // this.fullPageDialog = false; 
                    this.cdr.detectChanges();
                    clearInterval(checkInterval);
                }
                    this.fullPageDialog = false; 
            }, 300);
            setTimeout(() => {                
                this.privileges = JSON.parse(localStorage.getItem("RolePrivilege"))
                this.populateMenuItems(this.privileges, localStorage.getItem('selectedClientId'));
                this.cdr.detectChanges();
            }, 3000)
        }
    }
    ngAfterViewInit(): void {
        this.privileges = JSON.parse(localStorage.getItem("RolePrivilege"))
        this.populateMenuItems(this.privileges, localStorage.getItem('selectedClientId'));
        this.cdr.detectChanges();
    }
setActiveMenuItem(): void {
     const currentUrl = this.router.url;
  if ((currentUrl === '/user/search/document-grid'  || currentUrl.startsWith('/user/search/')) && this.app?.menuMode === 'horizontal') {
    this.activeIndex = 0;
  } else {
    if (currentUrl.includes('admin')) {
      this.activeIndex = 1;  // Highlight "Admin" menu
    } else if (currentUrl.includes('master-data')) {
      this.activeIndex = 2;  // Highlight "MasterData" menu
    }
  }
  }

    populateMenuItems(privileges, clientId) {
        if (clientId === null) {
            this.items = [
                {
                    label: 'Freight Audit',
                    icon: 'fas fa-file-search',
                    routerLink: ['search/application'],
                    imageIcon: '../../../../../assets/layout/images/Menu-items/document.svg',
                    tooltipOptions: {
                        tooltipLabel: "Documents"
                    },
                    visible: this.isSuperuser || privileges?.includes('VIEW_CLIENT_LIST'),
                    routerLinkActiveOptions: {
                        exact: true
                    }
                },
                {
                    label: 'Administration',
                    icon: 'fas fa-user-shield',
                    imageIcon: '../../../../../assets/layout/images/Menu-items/administration.svg',
                    id: 'admin',
                    visible: this.isSuperuser || privileges?.includes('VIEW_USER_LIST') || privileges?.includes('VIEW_ROLE_LIST') || privileges?.includes('VIEW_CLIENT_LIST') ||
                        privileges?.includes('VIEW_DOCUMENT_TYPE_LIST') || privileges?.includes('VIEW_CHARGE_SHEET_LIST') || privileges?.includes('VIEW_SYSTEM_ANNOUNCEMENT_LIST') || privileges?.includes('VIEW_COLUMN_SETTING_LIST'),
                    tooltipOptions: {
                        tooltipLabel: "Administration"
                    },
                    routerLinkActiveOptions: {
                        exact: true
                    },
                    items: [
                        {
                            label: 'User Management',
                            icon: 'fas fa-users-cog',
                            routerLink: ['admin/user-management'],
                            tooltipOptions: {
                                tooltipLabel: "User Management"
                            },
                            visible: this.isSuperuser || privileges?.includes('VIEW_USER_LIST'),
                            routerLinkActiveOptions: {
                                exact: true
                            }
                        },
                        {
                            label: 'Role Management',
                            icon: 'fas fa-user-check',
                            visible: this.isSuperuser || privileges?.includes('VIEW_ROLE_LIST'),
                            routerLink: ['admin/role-management'],
                            tooltipOptions: {
                                tooltipLabel: "Role Management"
                            },
                            routerLinkActiveOptions: {
                                exact: true
                            }
                        },
                        {
                            label: 'Document Type',
                            icon: 'fas fa-money-check-edit',
                            routerLink: ['admin/document-type'],
                            visible: this.isSuperuser || privileges?.includes('VIEW_DOCUMENT_TYPE_LIST'),
                            tooltipOptions: {
                                tooltipLabel: "Document Type"
                            },
                            routerLinkActiveOptions: {
                                exact: true
                            }
                        },
                        // {
                        //     label: 'File Type',
                        //     icon: 'far fa-tasks-alt',
                        //     routerLink: ['admin/file-type'],
                        //     // visible:this.isSuperuser,
                        //     tooltipOptions: {
                        //         tooltipLabel: "File Type"
                        //     },
                        //     routerLinkActiveOptions: {
                        //         exact: true
                        //     }
                        // },
                        {
                            label: 'Rate Sheet',
                            icon: 'fas fa-browser',
                            routerLink: ['admin/charge-sheet'],
                            visible: this.isSuperuser || privileges?.includes('VIEW_CHARGE_SHEET_LIST'),
                            tooltipOptions: {
                                tooltipLabel: "Rate Sheet"
                            },
                            routerLinkActiveOptions: {
                                exact: true
                            }
                        },
                        {
                            label: 'Client Management',
                            icon: 'far fa-file-certificate',
                            routerLink: ['super-admin/client'],
                            tooltipOptions: {
                                tooltipLabel: "Client Management"
                            },
                            visible: this.isSuperuser || privileges?.includes('VIEW_CLIENT_LIST'),
                            routerLinkActiveOptions: {
                                exact: true
                            }
                        },
                        {
                            label: 'Column Settings',
                            icon: 'fas fa-line-columns',
                            visible: this.isSuperuser || privileges?.includes('VIEW_COLUMN_SETTING_LIST'),
                            routerLink: ['admin/column-settings'],
                            tooltipOptions: {
                                tooltipLabel: "Column Settings"
                            },
                            routerLinkActiveOptions: {
                                exact: true
                            }
                        },
                        {
                            label: 'Announcement',
                            icon: 'fas fa-megaphone',
                            visible: this.isSuperuser || privileges?.includes('VIEW_SYSTEM_ANNOUNCEMENT_LIST'),
                            routerLink: ['admin/announcement'],
                            tooltipOptions: {
                                tooltipLabel: "Announcement"
                            },
                            routerLinkActiveOptions: {
                                exact: true
                            }
                        },
                        {
                            label: 'Billing',
                            icon: 'fas fa-file-invoice',
                            // visible:this.isSuperuser||privileges?.includes('VIEW_SYSTEM_ANNOUNCEMENT_LIST'),
                            routerLink: ['admin/billing-details'],
                            tooltipOptions: {
                                tooltipLabel: "Billing"
                            },
                            routerLinkActiveOptions: {
                                exact: true
                            }
                        }
                    ]
                },
                {
                    label: 'Master Data',
                    icon: 'fas fa-list',
                    imageIcon: '../../../../../assets/layout/images/Menu-items/masterdata.svg',
                    tooltipOptions: {
                        tooltipLabel: "Master Data"
                    },
                    visible: false && this.isSuperuser || privileges?.includes('VIEW_CURRENCY_LIST') || privileges?.includes('VIEW_CURRENCY_EXCHANGE_LIST'),    //added false to completely hide this
                    routerLinkActiveOptions: {
                        exact: true
                    },
                    items: [
                        // {
                        //     label: 'Currency Management',
                        //     icon: 'fal fa-rupee-sign',
                        //     routerLink: ['master-data/currency-management'],
                        //     visible: this.isSuperuser || privileges?.includes('VIEW_CURRENCY_LIST'),
                        //     tooltipOptions: {
                        //         tooltipLabel: "Currency Management"
                        //     },
                        //     routerLinkActiveOptions: {
                        //         exact: true
                        //     }
                        // },
                        // {
                        //     label: 'Currency Exchange',
                        //     icon: 'pi pi-book',
                        //     routerLink: ['master-data/currency-exchange'],
                        //     visible: this.isSuperuser || privileges?.includes('VIEW_CURRENCY_EXCHANGE_LIST'),
                        //     tooltipOptions: {
                        //         tooltipLabel: "Currency Exchange"
                        //     },
                        //     routerLinkActiveOptions: {
                        //         exact: true
                        //     }
                        // },

                    ]
                },
            ]
        }
        else {
            this.items = [
                {
                    label: 'Invoice Management',
                    icon: 'fas fa-file-search',
                    imageIcon: '../../../../../assets/layout/images/Menu-items/document.svg',
                    routerLink: ['search/document-grid'],
                    tooltipOptions: {
                        tooltipLabel: "Invoice Management"
                    },
                    visible: this.isSuperuser || privileges?.includes('VIEW_DOCUMENT_LIST'),
                    routerLinkActiveOptions: {
                        exact: true
                    }
                },
                {
                    label: 'Administration ',
                    icon: 'fas fa-user-shield',
                    imageIcon: '../../../../../assets/layout/images/Menu-items/administration.svg',
                    id: 'admin',
                    visible: this.isSuperuser || privileges?.includes('VIEW_USER_LIST') || privileges?.includes('VIEW_ROLE_LIST') || privileges?.includes('VIEW_VALIDATION_MODULE_LIST') || privileges?.includes('VIEW_ACTION_STATUS_LIST') || privileges?.includes('EMAIL_TEMPLATE_AUTO_LIST_VIEW') || privileges?.includes('EMAIL_TEMPLATE_MANUAL_LIST_VIEW') || privileges?.includes('EMAIL_TEMPLATE_MANUAL_PRIVATE_LIST_VIEW') || privileges?.includes('VIEW_USER_ACTIVITY_LOGS') || privileges?.includes('VIEW_CONNECTIVITY_SETUP_LIST') || privileges?.includes('VIEW_SYSTEM_ANNOUNCEMENT_LIST') || privileges?.includes('VIEW_COLUMN_SETTING_LIST') || privileges?.includes('VIEW_NAME_SURCHARGE_TOLERANCE'),
                    tooltipOptions: {
                        tooltipLabel: "Administration"
                    },
                    routerLinkActiveOptions: {
                        exact: true
                    },
                    items: [
                        {
                            label: 'User Management',
                            icon: 'fas fa-users-cog',
                            routerLink: ['admin/user-management'],
                            tooltipOptions: {
                                tooltipLabel: "User Management"
                            },
                            visible: this.isSuperuser || privileges?.includes('VIEW_USER_LIST'),
                            routerLinkActiveOptions: {
                                exact: true
                            }
                        },
                        {
                            label: 'Role Management',
                            icon: 'fas fa-user-check',
                            visible: this.isSuperuser || privileges?.includes('VIEW_ROLE_LIST'),
                            routerLink: ['admin/role-management'],
                            tooltipOptions: {
                                tooltipLabel: "Role Management"
                            },
                            routerLinkActiveOptions: {
                                exact: true
                            }
                        },
                        // {
                        //     label: 'Customer Management',
                        //     icon: 'pi pi-user',
                        //     routerLink: ['admin/customer-management'],
                        //     visible: this.isSuperuser || privileges?.includes('CUSTOMER_LIST'),
                        //     tooltipOptions: {
                        //         tooltipLabel: "Customer Management"
                        //     },
                        //     routerLinkActiveOptions: {
                        //         exact: true
                        //     }
                        // },

                        // {
                        //     label: 'Vendor Management',
                        //     icon: 'pi pi-user-plus',
                        //     routerLink: ['admin/vendor-management'],
                        //     visible: this.isSuperuser || privileges?.includes('VENDOR_LIST'),
                        //     tooltipOptions: {
                        //         tooltipLabel: "Vendor Management"
                        //     },
                        //     routerLinkActiveOptions: {
                        //         exact: true
                        //     }
                        // },
                        // {
                        //     label: 'Document Actions',
                        //     icon: 'fas fa-file-alt',
                        //     visible: this.isSuperuser || privileges?.includes('VIEW_ACTION_STATUS_LIST'),
                        //     routerLink: ['admin/docstatus-management'],
                        //     tooltipOptions: {
                        //         tooltipLabel: "Document Actions"
                        //     },
                        //     routerLinkActiveOptions: {
                        //         exact: true
                        //     }
                        // },
                        // {
                        //     label: 'Custom Email Template',
                        //     icon: 'fas fa-mail-bulk',
                        //     id: 'admin',
                        //     visible: this.isSuperuser || privileges?.includes('EMAIL_TEMPLATE_AUTO_LIST_VIEW') || privileges?.includes('EMAIL_TEMPLATE_MANUAL_LIST_VIEW') || privileges?.includes('EMAIL_TEMPLATE_MANUAL_PRIVATE_LIST_VIEW'),
                        //     expanded: window.location.href.includes('admin/auto-email-template') || window.location.href.includes('admin/manual-email-template'),
                        //     title: 'Custom Email Template',
                        //     routerLinkActiveOptions: {
                        //         exact: true
                        //     },
                        //     items: [
                        //         {
                        //             label: 'Auto Email Template',
                        //             icon: 'far fa-envelope-square',
                        //             routerLink: ['admin/auto-email-template'],
                        //             visible: this.isSuperuser || privileges?.includes('EMAIL_TEMPLATE_AUTO_LIST_VIEW'),
                        //             tooltipOptions: {
                        //                 tooltipLabel: "Auto Email Template"
                        //             },
                        //             routerLinkActiveOptions: {
                        //                 exact: true
                        //             }
                        //         },
                        //         {
                        //             label: 'Manual Email Template',
                        //             icon: 'fas fa-envelope',
                        //             routerLink: ['admin/manual-email-template'],
                        //             visible: this.isSuperuser || privileges?.includes('EMAIL_TEMPLATE_MANUAL_LIST_VIEW') || privileges?.includes('EMAIL_TEMPLATE_MANUAL_PRIVATE_LIST_VIEW'),
                        //             tooltipOptions: {
                        //                 tooltipLabel: "Manual Email Template"
                        //             },
                        //             routerLinkActiveOptions: {
                        //                 exact: true
                        //             }
                        //         },
                        //     ],
                        // },
                        {
                            label: 'Tolerance Config',
                            icon: 'fal fa-solid fa-chart-bar',
                            routerLink: ['admin/tolerance-config'],
                            visible: this.isSuperuser || privileges?.includes('VIEW_NAME_SURCHARGE_TOLERANCE'),
                            tooltipOptions: {
                                tooltipLabel: "Tolerance Configuration"
                            },
                            routerLinkActiveOptions: {
                                exact: true
                            }
                        },
                        {
                            label: 'Column Settings',
                            icon: 'fas fa-line-columns',
                            visible: this.isSuperuser || privileges?.includes('VIEW_COLUMN_SETTING_LIST'),
                            routerLink: ['admin/column-settings'],
                            tooltipOptions: {
                                tooltipLabel: "Column Settings"
                            },
                            routerLinkActiveOptions: {
                                exact: true
                            }
                        },
                        // {
                        //     label: 'BRE Config',
                        //     icon: 'fas fa-briefcase',
                        //     routerLink: ['master-data/bre'],
                        //     visible: this.isSuperuser || privileges?.includes('VIEW_VALIDATION_MODULE_LIST'),
                        //     tooltipOptions: {
                        //         tooltipLabel: "BRE Config"
                        //     },
                        //     routerLinkActiveOptions: {
                        //         exact: true
                        //     }
                        // },
                        // {
                        //     label: 'User Activity Log',
                        //     icon: 'fal fa-user-clock',
                        //     visible: this.isSuperuser || privileges?.includes('VIEW_USER_ACTIVITY_LOGS'),
                        //     routerLink: ['admin/user-activity'],
                        //     routerLinkActiveOptions: {
                        //         exact: true
                        //     },
                        //     tooltipOptions: {
                        //         tooltipLabel: "User Activity Log"
                        //     }
                        // },
                        // {
                        //     label: 'Announcement',
                        //     icon: 'fas fa-megaphone',
                        //     visible: this.isSuperuser || privileges?.includes('VIEW_SYSTEM_ANNOUNCEMENT_LIST'),
                        //     routerLink: ['admin/announcement'],
                        //     tooltipOptions: {
                        //         tooltipLabel: "Announcement"
                        //     },
                        //     routerLinkActiveOptions: {
                        //         exact: true
                        //     }
                        // },
                        // {
                        //     label: 'Connectivity',
                        //     icon: 'fas fa-router',
                        //     visible: this.isSuperuser || privileges?.includes('VIEW_CONNECTIVITY_SETUP_LIST'),
                        //     routerLink: ['admin/connectivity'],
                        //     routerLinkActiveOptions: {
                        //         exact: true
                        //     },
                        //     tooltipOptions: {
                        //         tooltipLabel: "Connectivity"
                        //     }
                        // },
                        // {
                        //     label: 'Error Code',
                        //     icon: 'fas fa-exclamation-triangle',
                        //     visible: this.isSuperuser || privileges?.includes('VIEW_ERROR_CODE_LIST'),
                        //     routerLink: ['admin/error-code'],
                        //     routerLinkActiveOptions: {
                        //         exact: true
                        //     },
                        //     tooltipOptions: {
                        //         tooltipLabel: "Error Code"
                        //     }
                        // },
                        // {
                        //     label: 'Billing',
                        //     icon: 'fas fa-file-invoice',
                        //     visible: this.isSuperuser || privileges?.includes('VIEW_BILLING_LIST'),
                        //     routerLink: ['admin/billing-details'],
                        //     routerLinkActiveOptions: {
                        //         exact: true
                        //     },
                        //     tooltipOptions: {
                        //         tooltipLabel: "Billing"
                        //     }
                        // }
                    ]
                },
                {
                    label: 'Master Data ',
                    icon: 'fas fa-list',
                    imageIcon: '../../../../../assets/layout/images/Menu-items/masterdata.svg',
                    id: 'master',
                    visible: this.isSuperuser || privileges?.includes('VIEW_CONTRACT_LIST') || privileges?.includes('VIEW_UOM_LIST') || privileges?.includes('VIEW_SECTOR_LIST') || privileges?.includes('VIEW_RATE_CARD_LIST') || privileges?.includes('VIEW_PURCHASE_ORDER_LIST') ||
                        privileges?.includes('VIEW_PURCHASE_ORDER_ITEM_LIST') || privileges?.includes('VIEW_SHIPMENT_LIST') || privileges?.includes('VIEW_CURRENCY_EXCHANGE_LIST') || privileges?.includes('VIEW_CURRENCY_ALIAS_LIST') || privileges?.includes('VIEW_CURRENCY_LIST') || privileges?.includes('VIEW_ZIP_ALIAS_LIST') || privileges?.includes('VIEW_VAT_ALIAS_LIST') || privileges?.includes('VIEW_SERVICE_TYPE_LIST'),
                    tooltipOptions: {
                        tooltipLabel: "Master Data"
                    },
                    routerLinkActiveOptions: {
                        exact: true
                    },
                    items: [
                        // {
                        //     label: 'Contract Management',
                        //     icon: 'pi pi-tablet',
                        //     routerLink: ['master-data/contract'],
                        //     visible: this.isSuperuser || privileges?.includes('VIEW_CONTRACT_LIST'),
                        //     tooltipOptions: {
                        //         tooltipLabel: "Contract Management"
                        //     },
                        //     routerLinkActiveOptions: {
                        //         exact: true
                        //     }
                        // },

                        {
                            label: 'Customer Management',
                            icon: 'pi pi-cog',
                            id: 'admin',
                            visible: this.isSuperuser || privileges?.includes('CUSTOMER_LIST') || privileges?.includes('CUSTOMER_LIST_SBU'),
                            expanded: window.location.href.includes('master-data/customer-management') || window.location.href.includes('master-data/customer-sbu-management'),
                            title: 'Customer Master Data',
                            routerLinkActiveOptions: {
                                exact: true
                            },
                            items: [
                                {
                                    label: 'Customer Master Data',
                                    icon: 'pi pi-user',
                                    routerLink: ['master-data/customer-management'],
                                    visible: this.isSuperuser || privileges?.includes('CUSTOMER_LIST'),
                                    tooltipOptions: {
                                        tooltipLabel: "Customer Master Data"
                                    },
                                    routerLinkActiveOptions: {
                                        exact: true
                                    }
                                },
                                {
                                    label: 'Customer SBU Master Data',
                                    icon: 'pi pi-users',
                                    routerLink: ['master-data/customer-sbu-management'],
                                    visible: this.isSuperuser || privileges?.includes('CUSTOMER_LIST'),
                                    tooltipOptions: {
                                        tooltipLabel: "Customer SBU Master Data"
                                    },
                                    routerLinkActiveOptions: {
                                        exact: true
                                    }
                                },
                            ],
                        },
                        {
                            label: ' Vendor Management',
                            icon: 'pi pi-truck',
                            routerLink: ['master-data/vendor-management'],
                            visible: this.isSuperuser || privileges?.includes('VENDOR_LIST'),
                            tooltipOptions: {
                                tooltipLabel: "Vendor Management"
                            },
                            routerLinkActiveOptions: {
                                exact: true
                            }
                        },
                        {
                            label: 'Shipment Management',
                            icon: 'pi pi-bars',
                            routerLink: ['master-data/shipment'],
                            visible: this.isSuperuser || privileges?.includes('VIEW_SHIPMENT_LIST'),
                            tooltipOptions: {
                                tooltipLabel: "Shipment Management"
                            },
                            routerLinkActiveOptions: {
                                exact: true
                            }
                        },
                        {
                            label: 'Rate Card Management',
                            icon: 'pi pi-book',
                            routerLink: ['master-data/rateCard'],
                            visible: this.isSuperuser || privileges?.includes('VIEW_RATE_CARD_LIST'),
                            tooltipOptions: {
                                tooltipLabel: "Rate Card Management"
                            },
                            routerLinkActiveOptions: {
                                exact: true
                            }
                        },
                         {
                           label: 'Surcharge Code Library',
                           icon: 'pi pi-tablet',
                           routerLink: ['master-data/surcharge-code-library'],
                           visible: this.isSuperuser || privileges?.includes('VIEW_NAME_SURCHARGE_CODE_LIBRARY'),
                           tooltipOptions: {
                               tooltipLabel: "Surcharge Code Library"
                           },
                     
                           routerLinkActiveOptions: {
                               exact: true
                           }
                       },
                        // {
                        //     label: 'PO Management',
                        //     icon: 'pi pi-tablet',
                        //     routerLink: ['master-data/po'],
                        //     visible: this.isSuperuser || privileges?.includes('VIEW_PURCHASE_ORDER_LIST') || privileges?.includes('VIEW_PURCHASE_ORDER_ITEM_LIST'),
                        //     tooltipOptions: {
                        //         tooltipLabel: "PO Management"
                        //     },
                        //     routerLinkActiveOptions: {
                        //         exact: true
                        //     }
                        // },
                        // {
                        //     label: 'Currency Exchange',
                        //     icon: 'pi pi-book',
                        //     routerLink: ['master-data/currency-exchange'],
                        //     visible: this.isSuperuser || privileges?.includes('VIEW_CURRENCY_EXCHANGE_LIST'),
                        //     tooltipOptions: {
                        //         tooltipLabel: "Currency Exchange"
                        //     },
                        //     routerLinkActiveOptions: {
                        //         exact: true
                        //     }
                        // },
                        // {
                        //     label: 'Currency Management',
                        //     icon: 'fal fa-rupee-sign',
                        //     routerLink: ['master-data/currency-management'],
                        //     visible: this.isSuperuser || privileges?.includes('VIEW_CURRENCY_LIST'),
                        //     tooltipOptions: {
                        //         tooltipLabel: "Currency Management"
                        //     },
                        //     routerLinkActiveOptions: {
                        //         exact: true
                        //     }
                        // },
                        {
                            label: 'UOM Management',
                            icon: 'fas fa-briefcase',
                            routerLink: ['master-data/uom-management'],
                            visible: this.isSuperuser || privileges?.includes('VIEW_UOM_LIST'),
                            tooltipOptions: {
                                tooltipLabel: "UOM Management"
                            },
                            routerLinkActiveOptions: {
                                exact: true
                            }
                        },
                        // {
                        //     label: 'Sector Management',
                        //     icon: 'fas fa-briefcase',
                        //     routerLink: ['master-data/sector-management'],
                        //     visible: this.isSuperuser || privileges?.includes('VIEW_SECTOR_LIST'),
                        //     tooltipOptions: {
                        //         tooltipLabel: "Sector Management"
                        //     },
                        //     routerLinkActiveOptions: {
                        //         exact: true
                        //     }
                        // },
                        // {
                        //     label: 'ZIP Alias',
                        //     icon: 'far fa-map-marked-alt',
                        //     routerLink: ['master-data/zip-alias'],
                        //     visible: this.isSuperuser || privileges?.includes('VIEW_ZIP_ALIAS_LIST'),
                        //     tooltipOptions: {
                        //         tooltipLabel: "ZIP Alias"
                        //     },
                        //     routerLinkActiveOptions: {
                        //         exact: true
                        //     }
                        // },
                        // {
                        //     label: 'Currency Alias',
                        //     icon: 'fas fa-sack-dollar',
                        //     routerLink: ['master-data/currency-alias'],
                        //     visible: this.isSuperuser || privileges?.includes('VIEW_CURRENCY_ALIAS_LIST'),
                        //     tooltipOptions: {
                        //         tooltipLabel: "Currency Alias"
                        //     },
                        //     routerLinkActiveOptions: {
                        //         exact: true
                        //     }
                        // },
                        // {
                        //     label: 'VAT Alias',
                        //     icon: 'fas fa-percent',
                        //     visible: this.isSuperuser || privileges?.includes('VIEW_VAT_ALIAS_LIST'),
                        //     routerLink: ['master-data/vat-alias'],
                        //     tooltipOptions: {
                        //         tooltipLabel: "VAT Alias"
                        //     },
                        //     routerLinkActiveOptions: {
                        //         exact: true
                        //     }
                        // },
                       {
                           label: 'Charge Type',
                           icon: 'pi pi-tablet',
                           routerLink: ['master-data/charge-type'],
                           visible: this.isSuperuser || privileges?.includes('VIEW_CHARGE_TYPE_LIST'),
                           tooltipOptions: {
                               tooltipLabel: "Charge Type"
                           },
                           routerLinkActiveOptions: {
                               exact: true
                           }
                       }

                    ]
                }
            ]
        }
        this.items = this.filterVisibleItems(this.items);
    }

    filterVisibleItems(items: any[]): any[] {
        return items
            .filter(item => item.visible !== false)
            .map(item => ({
                ...item,
                items: item.items ? this.filterVisibleItems(item.items) : undefined
            }));
    }
}

